import { createExtendedSystem } from './config';

export default createExtendedSystem();
